import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';
import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'tourdauer_anfahrt',
  label: 'Anfahrtszeit',
  valueFormat: '-#.###.##0,0 h',
  valueQuotient: 3600,
  chart: ChartType.bar,
  positiveDirection: PositiveDirection.down,
  category: 'tours',
  definition: getDefinitionByName('Anfahrtszeit'),
  hidden: true,
  targetValueType: TargetValueType.SUM,
});
